export default __webpack_public_path__ + "static/media/SelloISO.1e1da4a9.png";